import { Seeker } from './types';

export const generateAvatar = (name: string) => {
  const initials = name.split(' ').map(n => n[0]).join('').toUpperCase();
  const colors = [
    'bg-[#2C2731]',
    'bg-[#3A3340]',
    'bg-[#4B4353]',
    'bg-[#352F3B]',
    'bg-[#433B4A]',
    'bg-[#2E2836]'
  ];
  const colorIndex = name.length % colors.length;
  
  return (
    <div className={`w-8 h-8 rounded-full ${colors[colorIndex]} flex items-center justify-center text-[#FEF6D6] text-xs font-medium border border-[#FEF6D6]`}>
      {initials}
    </div>
  );
};

export const getStageTitle = (stage: string) => {
  switch (stage) {
    case 'matched': return 'Matched';
    case 'pending_consultation': return 'Consultation Scheduled';
    case 'awaiting_package': return 'Awaiting Package';
    case 'payment_pending': return 'Payment Pending';
    case 'active_clients': return 'Active Clients';
    default: return stage;
  }
};

export const getSeekersByStage = (seekers: Seeker[], stage: string) => {
  return seekers.filter(seeker => seeker.stage === stage);
};

export const getStageCount = (seekers: Seeker[], stage: string) => {
  return getSeekersByStage(seekers, stage).length;
};

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  }).format(amount);
};
